var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErdnPlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "px",
    height: "px",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,45.490196%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 20.765625 175.820312 C 23.585938 175.847656 26.386719 177.511719 27.226562 180.8125 L 40.972656 234.710938 C 41.242188 235.765625 41.378906 236.847656 41.378906 237.929688 L 68.992188 203.449219 L 55.171875 155.171875 Z M 20.765625 175.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,36.862745%,45.882353%)",
      fillOpacity: 1
    },
    d: "M 358.621094 237.929688 L 41.378906 237.929688 L 68.992188 203.449219 L 331.0625 203.449219 Z M 358.621094 237.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.137255%,56.862745%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 331.0625 203.449219 L 344.828125 155.171875 L 344.828125 101.722656 C 344.828125 85.539062 331.703125 72.414062 315.515625 72.414062 L 229.308594 72.414062 C 213.125 72.414062 200 85.539062 200 101.722656 L 200 203.449219 Z M 331.0625 203.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.352941%,71.372549%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 200.027344 203.449219 L 200.027344 101.722656 C 200.027344 85.539062 186.902344 72.414062 170.71875 72.414062 L 84.511719 72.414062 C 68.324219 72.414062 55.199219 85.539062 55.199219 101.722656 L 55.199219 155.171875 L 68.992188 203.449219 Z M 200.027344 203.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.490196%,45.490196%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 379.234375 175.820312 C 376.414062 175.847656 373.613281 177.511719 372.773438 180.8125 L 359.027344 234.710938 C 358.757812 235.765625 358.621094 236.847656 358.621094 237.929688 L 331.0625 203.449219 L 344.828125 155.171875 Z M 379.234375 175.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,28.235294%,21.176471%)",
      fillOpacity: 1
    },
    d: "M 48.277344 327.585938 L 41.378906 327.585938 L 41.378906 300 L 75.863281 300 Z M 48.277344 327.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,28.235294%,21.176471%)",
      fillOpacity: 1
    },
    d: "M 351.722656 327.585938 L 358.621094 327.585938 L 358.621094 300 L 324.136719 300 Z M 351.722656 327.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.333333%,82.745098%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 40.972656 234.710938 L 27.226562 180.8125 C 25.523438 174.136719 15.855469 174.136719 14.152344 180.8125 L 0.40625 234.710938 C -0.132812 236.828125 -0.132812 239.042969 0.40625 241.152344 L 14.152344 295.046875 C 15.042969 298.53125 18.097656 300.152344 21.0625 300 L 41.378906 300 L 41.378906 237.929688 C 41.378906 236.847656 41.242188 235.765625 40.972656 234.710938 Z M 40.972656 234.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.333333%,82.745098%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 399.59375 234.710938 L 385.847656 180.8125 C 384.144531 174.136719 374.476562 174.136719 372.773438 180.8125 L 359.027344 234.710938 C 358.757812 235.765625 358.621094 236.847656 358.621094 237.929688 L 358.621094 300 L 378.9375 300 C 381.902344 300.152344 384.957031 298.53125 385.847656 295.046875 L 399.59375 241.152344 C 400.136719 239.035156 400.136719 236.828125 399.59375 234.710938 Z M 399.59375 234.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.333333%,82.745098%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 358.621094 237.929688 L 41.378906 237.929688 L 41.378906 300 L 358.621094 300 Z M 358.621094 237.929688 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErdnPlogo);
export default __webpack_public_path__ + "static/media/ERDNPlogo.e9bd597a90c39fb360395137d91dc303.svg";
export { ForwardRef as ReactComponent };